import { StarIcon } from "@heroicons/react/24/solid";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

export interface StartRatingProps {
  className?: string;
  notation?: number;
  totalRating?: number;
  color?: string;
}

const StartRating: FC<StartRatingProps> = ({
  className = "",
  notation = 0,
  totalRating = 0,
  color
}) => {
  const { t } = useTranslation("guydeez");

  return (
    <div
      className={`nc-StartRating flex items-center space-x-1 text-sm ${className}`}
      data-nc-id="StartRating"
    >
      <div className="pb-[2px]">
        <StarIcon className="w-[18px] h-[18px] text-orange-500" />
      </div>
      {notation > 2.5 ? (
        <>
          <span className="font-medium">{notation.toFixed(1)}</span>
          <span className={`${color ? `${color}` : "text-neutral-500 dark:text-neutral-400 "}`}>
            ({totalRating} {totalRating > 1 ? t("components_reviews") : t("components_review")})
          </span>
        </>
      ) : (
        <span className={`${color ? `${color}` : "text-neutral-500 dark:text-neutral-400 "}`}>
          (0 {t("components_reviews")})
        </span>
      )}
    </div>
  );
};

export default StartRating;
